import { Loader2 } from 'lucide-react';

interface LoadingSpinnerProps {
  /** Optional message to display below the spinner */
  message?: string;
}

/**
 * Fullscreen loading spinner component
 *
 * Used during auth state check and other loading states
 */
export function LoadingSpinner({ message }: LoadingSpinnerProps) {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-background">
      <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      {message && <p className="mt-4 text-sm text-muted-foreground">{message}</p>}
    </div>
  );
}
